<template>
    <div class="wrapper">
        <ConfirmHeader />
        <main class="container">
            <section v-for="(category, i) in buildConfirm($props.level)" :key="i">
                <h2>{{ category.title }} </h2>
                <ul class="questions list-group">
                    <li v-for="(q, j) in category.q" :key="j" class="list-group-item">
                        <p>{{ q.text }} </p>
                        <AnswerOptions :options="category.options" :name="q.key" :index="q.ansIndex" />
                    </li>
                </ul>
            </section>
        </main>
        <p v-if="confirmMsg">{{ body.fillErrorMsg }} </p>
        <ConfirmFooter @goback="goBack" @gonext="goNext" class="confirm-footer" :footer="body.footer" />
        <ModalPersonalForm @on-submit="goResult" :level="$props.level" :args="modalArgs" />
    </div>
</template>

<script>
import ConfirmHeader from './Confirm/ConfirmHeader'
import ConfirmFooter from './Confirm/ConfirmFooter'
import AnswerOptions from './Common/AnswerOptions'
import ErrorPage from './ErrorPage'
import ModalPersonalForm from './Confirm/ModalPersonalForm'

import query from '../assets/js/query'
import confirm from '../assets/json/confirm.json'

export default {
    data: function() {
        return {
            confirmMsg: false,
            confirm: confirm,
        }
    },
    props: [
        'level'
    ],
    components: {
        ConfirmHeader,
        ConfirmFooter,
        AnswerOptions,
        ModalPersonalForm,
        ErrorPage
    },
    computed: {
        body: function() {
            if(window.location.href.includes("-en")){
                return confirm.en;
            }else if(window.location.href.includes("-cn")){
                return confirm.cn;
            }else if(window.location.href.includes("-pt")){
                return confirm.pt;
            }else if(window.location.href.includes("-sn")){
                return confirm.sn;
            }else if(window.location.href.includes("-tg")){
                return confirm.tg;
            }else{
                return confirm.jp;
            }

            
        },
        modalArgs: function() {
            if(this.$props.level.includes('covid19')) return this.body.covidModalArgs;
            return this.body.modalArgs;
        }
    },
    methods: {
        goBack: function () {
            this.$router.push({ path: '/content/' + this.$props.level + '/0'});
        },
        /* 得点を見るが押されたらアンケートフォームモーダルを開く */
        goNext: function() {
            // 未入力がないかチェックする
            const array = this.$store.state.answerData.slice(0, this.getTotalLength(this.$props.level));
            const done = array.filter(v=>v==0 || v==1 || v==2);
            console.log(array, done);
            if(array.length != done.length){
                this.confirmMsg = true;
                return;
            }
            this.confirmMsg = false;
            this.$modal.show('modal-personal-form');
        },
        goResult: function() {
            const array = this.$store.state.answerData.slice(0, this.getTotalLength(this.$props.level));
            const q = query.array2queryStr(array);
            console.log(q);
            this.$router.push({ path: '/result/' + this.$props.level + '?a=' + q});
        }
    },
}
</script>

<style>
    .confirm-footer {
        margin-top: 24px;
    }
</style>